import { Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import {
    Business,
    PointOfSale,
    Article,
    People,
    BarChart,
    MedicalServices,
    Quiz
} from '@mui/icons-material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import './Home.css';

const Home = () => {
    const { companyName, username, roleName } = useAuth();

    return (
        <div>
            {/* Header */}
          
        

            {/* Footer */}
            <div style={{
                position: 'fixed',
                bottom: '12px',
                right: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.3rem 0.65rem',
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '14px',
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                fontFamily: 'serif',
                fontWeight: 'bold',
                color: '#2c3e50',
                fontSize: '0.7rem',
                backdropFilter: 'blur(10px)'
            }}>
                <CopyrightIcon />
                <b>EFFTABS SOLUTIONS LLP</b>
            </div>
        </div>
    );
};

export default Home;
